var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.code,
            expression: "code"
          }
        ],
        staticStyle: { width: "100%", height: "15em" },
        domProps: { value: _vm.code },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.code = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _vm.errors.length > 0
        ? _c(
            "div",
            _vm._l(_vm.errors, function(error) {
              return _c("pre", { key: error }, [_vm._v(_vm._s(error))])
            }),
            0
          )
        : _vm.is
        ? _c(_vm.is, { tag: "component" })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }